export default __webpack_public_path__ + "static/phone-white-spanish-80d37be383956db6e276ee3c2da32460.mp4";